import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, SectionTitle } from "./common";
import { FAQS } from "@/lib/site";

export const Faq = () => {
  return (
    <section id="faq" data-testid="faq-section" className="pb-14 sm:pb-20">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6">
        <Reveal>
          <SectionTitle eyebrow="Dudas frecuentes" title="Preguntas frecuentes" />
        </Reveal>
        <Reveal delay={0.05}>
          <Accordion type="single" collapsible className="mt-8 space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid="faq-item"
                className="overflow-hidden rounded-2xl border border-[hsl(var(--border))] bg-white px-5 shadow-[0_6px_18px_rgba(31,41,55,0.05)]"
              >
                <AccordionTrigger className="py-4 text-left font-heading text-base font-bold text-[hsl(var(--brand-ink))] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-4 text-sm leading-relaxed text-muted-foreground">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
